var map = {
	"./Advertisement": 9011,
	"./Advertisement.js": 9011,
	"./ArchiveAdvertisement": 3670,
	"./ArchiveAdvertisement.js": 3670,
	"./ArchiveCirculars": 1448,
	"./ArchiveCirculars.js": 1448,
	"./ArchiveNews": 1822,
	"./ArchiveNews.js": 1822,
	"./ArchiveNewsDetails": 3044,
	"./ArchiveNewsDetails.js": 3044,
	"./ArchiveNewsDetailsData": 7321,
	"./ArchiveNewsDetailsData.js": 7321,
	"./ArchiveTender": 434,
	"./ArchiveTender.js": 434,
	"./NewsAndEvents": 4964,
	"./NewsAndEvents.js": 4964,
	"./NewsAndEventsDetails": 5215,
	"./NewsAndEventsDetails.js": 5215,
	"./NewsEventSidebar": 7843,
	"./NewsEventSidebar.js": 7843,
	"./Tenders": 8628,
	"./Tenders.js": 8628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3186;